<template lang='pug'>
//- Side-Effect-ChatRoom
div(:class='$style[`cc-side-effect-chatRoom`]')
  div(:class='$style[`cc-side-effect-chatRoom-header`]')
    div(:class='$style[`cc-side-effect-chatRoom-title`]')
      router-link.btn-extra(
        exact=true
        role='button'
        tabindex='0' aria-label='返回諮詢列表'
        :to='`/sideeffect/consult`'
        :class='$style[`cc-side-effect-chatRoom-return-btn`]')
        IconOpenArrow(:size='20' :color='`#262626`')
        span 返回

    div.font-bold(:class='$style[`cc-side-effect-chatRoom-service`]')
      //- figure(:class='$style[`cc-side-effect-chatRoom-service-avatar`]')
      //-   img(
      //-     :src='avatarSrcLink(vendorProfile.thumbSrc)'
      //-     width='100%'
      //-     height='100%')
      span(:class='$style[`cc-side-effect-chatRoom-service-text`]') {{ vendorProfile.name }}
        i(v-if='vendorProfile.service === `free`' :class='$style[`cc-side-effect-chatRoom-service-free`]') 限時試用

    div(:class='$style[`cc-side-effect-chatRoom-vendor`]')
      button(
        tabindex='0' aria-label='醫護團隊'
        :class='$style[`cc-side-effect-chatRoom-vendor-btn`]'
        @click='handleClickShowVendorProfile(vendorId)') 醫護團隊

  //- 對話內容區
  div.custom-scrollbar(:class='$style[`cc-side-effect-chatRoom-wrap`]')
    div(v-if='preloading' :class='$style[`cc-side-effect-chatRoom-container`]')
      div(:class='$style[`cc-side-effect-chatRoom-loader`]')
        IconLoading(:size='36' :color='`#b1b1b1`')

    //- div(v-else :class='[$style[`cc-side-effect-chatRoom-container`], $style[subscribeVip === `yes` ? `` : `full-height`]]')
    div(v-else :class='$style[`cc-side-effect-chatRoom-container`]')
      //- infinite-loading(direction='top' :identifier='infiniteId' @infinite='infiniteHandler' forceUseInfiniteWrapper=true)
      //- forceUseInfiniteWrapper=true
      infinite-loading(
        direction='top' :distance=200
        :identifier='infiniteId' @infinite='infiniteHandler')
        IconLoading(
          slot='spinner'
          :size='10'
          :color='`#b1b1b1`'
          style='display: none;')
          //- IconLoading(slot='spinner' :size='16' :color='`#b1b1b1`')
        div.infinite-scroll-slot(slot='no-more' style='display: none; font-size: 0')
          span.infinite-scroll-slot-noMore 沒有更多資料
        div.infinite-scroll-slot(slot='no-results' style='display: none; font-size: 0')
          span.infinite-scroll-slot-noMore 沒有更多資料

      //- span(
      //-   v-if='!historyMsg.length'
      //-   :class='$style[`cc-side-effect-chatRoom-norecord`]') 沒有諮詢記錄

      //- ul(
      //-   id='chatDialog' ref='chatDialog'
      //-   :class='[$style[`cc-side-effect-chatRoom-dialog`], $style[wsMsgLoading ? `opacity-hide` : ``]]')
      //- ref='chatDialog'
      ul#chatDialog(
        :class='$style[`cc-side-effect-chatRoom-dialog`]')

        //- 歷史記錄
        li(
          v-for='(items, index) in historyMsg.slice().reverse()'
          :id='`history-${index}`'
          :key='`history-${index}`'
          :class='$style[`cc-side-effect-chatRoom-dialog-li`]')
          span(
            v-if='items.isFirst'
            :class='$style[`cc-side-effect-chatRoom-datetips`]') {{ items.isFirst }}
          EffectChatRoomMsg(
            :index='index'
            :dialog='`history`'
            :message_id='items.id'
            :room='`${vendorId}-${loginHashCode}-${loginDjangoId}`',
            :category='items.category === `text` && items.message.includes(`{\"mall\": \"stuff\"`) ? `stuff` : items.category'
            :message='items.message'
            :extra_text='items.extra_text'
            :userType='items.user_type'
            :gender='items.gender'
            :thumbSrc='items.thumbSrc'
            :firstName='items.firstName'
            :lastName='items.lastName'
            :character='items.character'
            :evaluate='items.evaluate'
            :notes='items.notes'
            :real_reply='items.id === forceUpdateMsgId ? true : items.real_reply')

          //- @scrollToMessage='detectScrollToMessage')
          //- span(style='font-size: 13px; margin: 10px 0') {{ items.message }}
          //- EffectChatRoomMsg(
          //-   v-if='items.category === `text` && items.message.includes(`{\"mall\": \"stuff\"`)'
          //-   :msgContent='{ category: `stuff`, content: JSON.parse(items.message) }'
          //-   :msgData='items'
          //-   :key='index')
          //- EffectChatRoomMsg(
          //-   v-if='items.category === `img`'
          //-   :msgContent='{ category: `img`, content: items.message }'
          //-   :msgData='items'
          //-   :key='index')
          //- EffectChatRoomMsg(
          //-   v-else
          //-   :msgContent='{ category: `text`, content: items.message }'
          //-   :msgData='items'
          //-   :key='index')


        //- 當前對話
        li(
          v-for='(items, index) in wsMsg'
          :id='`ws-${index}`'
          :key='`ws-${index}`'
          :class='$style[`cc-side-effect-chatRoom-dialog-li`]')
          EffectChatRoomMsg(
            :index='index'
            :dialog='`ws`'
            :message_id='items.id'
            :room='`${vendorId}-${loginHashCode}-${loginDjangoId}`',
            :category='items.category === `text` && items.message.includes(`{\"mall\": \"stuff\"`) ? `stuff` : items.category'
            :message='items.message'
            :extra_text='items.extra_text'
            :userType='items.user_type'
            :gender='items.gender'
            :thumbSrc='items.thumbSrc'
            :firstName='items.firstName'
            :lastName='items.lastName'
            :character='items.character'
            :evaluate='items.evaluate'
            :notes='items.notes'
            :real_reply='items.id === forceUpdateMsgId ? true : items.real_reply')


        //- Ai回答產生中
        li(v-if='detectAiReply' :class='$style[`cc-side-effect-chatRoom-dialog-li`]')
          div(:class='$style[`cc-dialog-progress-loading`]')
            ProgressBar(
              :loadAnimate='true'
              :labelValue='0')
            div(:class='$style[`cc-dialog-progress-feature`]')
              span.font-medium(:class='$style[`cc-dialog-progress-feature-text`]') Dr.Cell 回覆中 (請定期更新病歷以提供精準回覆)


  div(:class='$style[`cc-side-effect-chatRoom-controller`]')
    div(v-if='showSendInterface' :class='$style[`cc-side-effect-chatRoom-controller-inputer`]')
      TextAreaer(
        v-model='sendMsg'
        ref='texter'
        :key='nextTick'
        :defaultValue='sendMsg'
        :autoSize='true'
        :class='$style[`cc-input-textarea`]'
        :emojiButton='true'
        :resetButton='false'
        :placehold='`右側笑臉可輸入表情符號`'
        :errorValue='sendMsgError'
        @clearErrorMsg="(value) => {this.sendMsgError = value[0]; this.sendMsgErrorLog = '';}")

      div(:class='$style[`cc-side-effect-chatRoom-controller-inputer-interactive`]')
        button(
          v-if='vendorId === `0`'
          :disabled='!sendMsg'
          :class='$style[`cc-side-effect-chatRoom-inputer-send-ai`]'
          tabindex='0' aria-label='傳送訊息並由AI回覆'
          @click.once='debounceSendNewMessageWithAi') 傳送問 AI 
          IconFlash(:size='14' :color='`#fff`')

        button(
          v-else
          :disabled='!sendMsg'
          :class='$style[`cc-side-effect-chatRoom-inputer-send`]'
          tabindex='0' aria-label='僅傳送訊息'
          @click.once='debounceSendNewMessage') 傳送問醫生

        button(
          :class='$style[`cc-side-effect-chatRoom-inputer-close`]'
          tabindex='0' aria-label='關閉輸入介面'
          @click='showSendInterface = !showSendInterface') 取消

    //-  主要
    div(:class='$style[`cc-side-effect-chatRoom-controller-main`]')
      button(
        :class='$style[`cc-side-effect-chatRoom-send`]'
        tabindex='0' aria-label='輸入訊息..' @click='handleClickOpenSendInterface') {{ showSendInterface ? '上方輸入訊息' : '輸入訊息..' }}

    //- 工具列
    div(:class='$style[`cc-side-effect-chatRoom-controller-tool`]')
      button(
        v-if='vendorId !== `0`'
        tabindex='0' aria-label='上傳圖檔'
        :class='[$style[`cc-side-effect-chatRoom-widget`], $style[`cc-side-effect-chatRoom-upload`]]'
        @click='uploadNewPhoto')
        IconAttachFile(:size='22' :color='`#262626`')
        != '圖片'

      button(
        v-if='newSpeech.isSupported'
        tabindex='0' aria-label='語音輸入訊息'
        :class='[$style[`cc-side-effect-chatRoom-widget`], $style[`cc-side-effect-chatRoom-upload`]]'
        @click='speechInputMessage')
        IconMic(:size='22' :color='`#262626`')
        != '輸入'

      //- button.btn-extra(
      //-   tabindex='0' aria-label='下載對話紀錄'
      //-   :class='$style[`cc-side-effect-chatRoom-download-record`]'
      //-   @click='downloadChatRecord')
      //-   IconDownload2(:size='26' :color='`#262626`')
      //-   != '對話'



</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { useSpeechRecognition } from '@vueuse/core';
// const {
//   isSupported, isListening, isFinal, result, start, stop
// } = useSpeechRecognition({
//   lang: 'cmn-Hant-TW',
//   interimResults: true,
//   continuous: true,
// });

import { debounce } from 'debounce';
import Inputer from '../common/Input';
// import Select from '../common/Select';
import TextAreaer from '../common/TextArea';
import IconLoading from '../../icon/Loading';
import IconAttachFile from '../../icon/AttachFile';
import IconMic from '../../icon/Mic';
import IconFlash from '../../icon/Flash';
import IconOpenArrow from '../../icon/OpenArrow';
// import IconDrCell from '../../icon/DrCell';

import EffectChatRoomMsg from './EffectChatRoomMsg';
import ProgressBar from '../common/ProgressBar';
import GlobalEmitter from 'tiny-emitter/instance';
// import { mixin as clickaway } from 'vue-clickaway';

import {
  putChatHistoryList,
  putLoadVendorProfile,
  putChatUserRead,
  postAiConsultation,
  // putChatRoomRecordDownload,
} from '../../../js/restapi';

export default {
  components: {
    Inputer,
    TextAreaer,
    // Select,
    IconLoading,
    IconMic,
    IconAttachFile,
    IconFlash,
    IconOpenArrow,
    ProgressBar,
    EffectChatRoomMsg,
  },

  created() {
    if (this.$route.query.v) {
      document.body.classList.add('cc-overflow-hide');
      document.documentElement.style.overflow = 'hidden';

      window.addEventListener('beforeunload', e => this.closeWebSocket(e));
      this.pageLoadStartProcess();
    }

    this.detectGlobalEmitter();
  },

  destroyed() {
    document.body.classList.remove('cc-overflow-hide');
    document.documentElement.style.overflow = 'unset';
  },

  beforeDestroy() {
    this.closeWebSocket();
    window.removeEventListener('beforeunload', e => this.closeWebSocket(e));
  },

  data() {
    return {
      lazyLoad: true,
      // infiniteActive: false,
      detectAiReply: false,
      newSpeech: useSpeechRecognition(),

      vendorId: this.$route.query.v || '',
      readProfile: this.$route.query.c || 'no',
      vendorProfile: {},
      // showNoPersonalData: false,
      // showScrollTips: false,
      showScrollLoad: true,
      preloading: true,
      // showTyping: false,
      // showTutorial: false,
      showSendInterface: false,
      sendMsg: '',
      sendMsgError: false,
      sendMsgErrorLog: '請輸入訊息',
      verifyAllPass: true,
      historyMsg: [],
      wsMsg: [],
      wsRoom: null,
      // wsReadState: 0,
      errorDetect: false,
      // wsMsgLoading: true,
      pageIndex: 1,
      pageSize: 20,
      nextTick: 1,
      forceUpdateMsgId: 0,
      infiniteId: +new Date(),
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      updateChatRemind: 'user/USER_UPDATE_CHAT_REMIND',
      updateConsultWebSocket: 'user/CONSULT_WEBSOCKET',
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
      changePopVendorProfileStatus: 'global/POPVENDORPROFILE_STATUS',
      // changeUpdateKey: 'global/FORCE_UPDATE_KEY',
    }),

    infiniteHandler($state) {
      if (!this.lazyLoad) {
        const PASS_CONFIG = {
          auth_id: `${this.loginDjangoId}`,
          team_id: this.vendorId,
          page: this.pageIndex,
          size: this.pageSize,
        }
        putChatHistoryList('', PASS_CONFIG, {})
          .then((res) => {
            console.log('Res', res);
            res.data.results.map((x) => this.historyMsg.push(x));

            if (res.data.results.length < this.pageSize || this.historyMsg.length === res.data.count) {
              $state.complete();

              // if (this.rwdType !== 'desktop') {
              //   setTimeout(() => {
              //     this.handleScrollBottom();
              //     // this.wsMsgLoading = false;
              //   }, 100);
              // }

              setTimeout(() => {
                this.handleScrollBottom();
                // this.wsMsgLoading = false;
              }, 100);
            } else {
              this.pageIndex += 1;
            }
            // this.wsMsgLoading = false;
            $state.loaded();
          })
          .catch((err) => {
          })
      } else {
        $state.complete();
        // this.wsMsgLoading = false;
      }
    },

    closeWebSocket(e) {
      if (this.wsRoom) {
        this.wsRoom.close();
      }
    },

    detectGlobalEmitter() {
      let vm = this;

      GlobalEmitter.on('create-speech', function (arg) {
        vm.showSendInterface = true;
        vm.sendMsg = arg.speech;
        vm.nextTick += 1;
        // console.log('GlobalEmitter Create speech', arg, vm.sendMsg, vm.nextTick);
      });

      GlobalEmitter.on('send-chat-additional', function (arg) {
        // console.log('send-chat-additional', arg);
        vm.forceUpdateMsgId = arg.msgId;
      });
    },

    pageLoadStartProcess() {
      // console.log('pageLoadStartProcess', this.vendorId);
      putLoadVendorProfile('', {
        team_id: this.vendorId,
      })
        .then((res) => {
          console.log('putLoadVendorProfile', res.data);
          this.vendorProfile = res.data;
          this.axiosLoadChatHistory();
          this.initRoomWebsocket();
          this.detectGlobalEmitter();

          if (this.readProfile === `no`) {
            this.handleClickShowVendorProfile(this.vendorId);
          }
        })
        .catch((err) => {
          this.$router.replace({
            name: 'error404',
          }).catch(()=>{});
        });
    },

    handleClickShowSubscribeExpire() {
      this.changePopShowTutorialStatus({
        active: true,
        include: 'subscribe-vip',
      });
    },

    handleClickShowVendorProfile(vid) {
      console.log('vid', vid);
      this.changePopVendorProfileStatus({
        active: true,
        detail: this.vendorProfile,
      });
    },

    handleScrollBottom() {
      const domScroll = document.getElementById('chatDialog');

      if (domScroll) {
        domScroll.scrollIntoView({
          behavior: 'auto',
          block: 'end'
        });
      }

      // if (this.rwdType === 'desktop' && domScroll) {
      //   domScroll.scrollIntoView({
      //     behavior: 'auto',
      //     block: 'end'
      //   });
      //   console.log('scrollIntoView')
      // } else if (this.rwdType !== 'desktop' && domScroll) {
      //   window.scrollTo({
      //     top: document.body.scrollHeight,
      //     behavior: 'instant',
      //   });
      //   console.log('scrollTo')
      // }
    },

    handleScrollBottomSmooth() {
      const domScroll = document.getElementById('chatDialog');
      if (domScroll) {
        domScroll.scrollIntoView({
          behavior: 'smooth',
          block: 'end'
        });
      }

      //  if (this.rwdType === 'desktop' && domScroll) {
      //   domScroll.scrollIntoView({
      //     behavior: 'smooth',
      //     block: 'end'
      //   });
      // } else if (this.rwdType !== 'desktop' && domScroll) {
      //   window.scrollTo({
      //     top: document.body.scrollHeight,
      //     behavior: 'smooth',
      //   });
      // }
    },

    axiosUpdateUserRead(room_name) {
      putChatUserRead('', {
        room_name,
      })
        .then((res) => {
          console.log('Update Read');
          this.updateChatRemind('');
        })
        .catch((err) => {
          console.log('err')
        })
    },

    axiosLoadChatHistory() {
      const PASS_CONFIG = {
        auth_id: `${this.loginDjangoId}`,
        team_id: this.vendorId,
        page: this.pageIndex,
        size: this.pageSize,
      }

      putChatHistoryList('', PASS_CONFIG, {})
        .then((res) => {
          const room = `${this.vendorId}-${this.loginHashCode}-${this.loginDjangoId}`;

          const loadProcess = new Promise((resolve) => {
            // if (!res.data.count || res.data.count <= this.pageSize) {
            //   this.showScrollTips = false;
            // } else {
            //   this.showScrollTips = true;
            // }
            this.historyMsg = res.data.results;
            this.pageIndex += 1;
            this.infiniteId += 1;
            this.lazyLoad = false;
            this.preloading = false;
            return resolve('done');
          })

          loadProcess.then((value) => {
            if (value === 'done') {
              this.axiosUpdateUserRead(room);
              
              setTimeout(() => {
                this.handleScrollBottom();
              }, 100);

              // if (this.rwdType === 'desktop') {
              //   this.wsMsgLoading = false;
              // }
            }
          })
        })
        .catch((err) => {
          this.changePopBoxStatus({
            active: true,
            include: 'warnError',
          });
        })
    },

    initRoomWebsocket() {
      if (process.env.NODE_ENV === 'production') {
        this.wsRoom = new WebSocket(`${this.WS_HEAD}://${window.location.host}/ws/${this.vendorId}-${this.loginHashCode}-${this.loginDjangoId}/`);
      } else {
        this.wsRoom = new WebSocket(`${'https:' === document.location.protocol ? 'wss' : 'ws'}:${process.env.VUE_APP_BACKEND}/ws/${this.vendorId}-${this.loginHashCode}-${this.loginDjangoId}/`);
      }

      this.updateConsultWebSocket({
        ws: this.wsRoom,
        room: `${this.vendorId}-${this.loginHashCode}-${this.loginDjangoId}`
      });

      this.wsRoom.onopen = this.wsonopen;
      this.wsRoom.onmessage = this.wsonmessage;
      this.wsRoom.onerror = this.wsonerror;
      this.wsRoom.onclose = this.wsclose;
      console.log('WebSocket ChatRoom', this.wsRoom, this.wsRoom.readyState);
    },

    wsonopen() {
      // this.wsReadState = this.wsRoom.readyState;
      this.errorDetect = false;
      console.log('WS Board 連線成功!', this.wsRoom.readyState);
    },

    wsonerror(e) {
      // this.wsReadState = 3;
      this.errorDetect = true;
      console.error('WS 連線失敗!', e);
    },

    wsclose() {
      // this.wsReadState = 3;
      this.errorDetect = true;
      console.log('WS Board 關閉連線', this.wsRoom.readyState);
    },

    wsonmessage(e) {
      // 後端通知前端，前端取得資料
      if (this.errorDetect) {
        this.wsRoom = null;
        this.changePopBoxStatus({
          active: true,
          include: 'warnWebSocketError',
        });
        return;
      }

      let _data = JSON.parse(e.data);

      if (_data.chatgpt === 'chat_consultation') {
        console.log('chat_consultation');
        this.detectAiReply = false;
      } else if (_data.chatgpt === 'drcell_error') {
        this.changePopBoxStatus({
          active: true,
          include: 'warnDrcellError',
        });
      }
      
      if (_data.category === 'text' || _data.category === 'ai-text' || _data.category === 'img') {

        // if (_data.message === 'typing' && !_data.username) {
        //   this.showTyping = true;
        //   setTimeout(() => {
        //     this.showTyping = false;
        //   }, 2500);
        // } else {

        console.log('Not chat_consultation', _data);
        this.wsMsg.push({
          id: _data.id,
          category: _data.category,
          message: _data.message,
          extra_text: _data.extra_text,
          user_type: _data.user_type,
          firstName: _data.first_name,
          lastName: _data.last_name,
          gender: _data.gender,
          thumbSrc: _data.thumbSrc,
          character: _data.character,
          notes: _data.notes,
        });
  
        setTimeout(() => {
          this.handleScrollBottomSmooth();
        }, 50);
        console.log('ws 取得資料', _data, this.wsMsg);
      }
    },

    handleClickOpenSendInterface() {
      this.showSendInterface = !this.showSendInterface;
      // this.$refs['sender'].$refs['texter'].focus();
      // this.$nextTick(() => {
      //   this.$refs['sender'].$refs['texter'].focus();
      // })
    },

    handleSendNewMessage() {
      if (!this.verifyAllPass) { return; }

      const SEND_MSG = {
        category: 'text',
        user_type: this.loginProfile.user_type,
        message: this.sendMsg,
        username: this.loginDjangoId,
        room: `${this.vendorId}-${this.loginHashCode}-${this.loginDjangoId}`,
        first_name: this.loginProfile.firstName,
        last_name: this.loginProfile.lastName,
        gender: this.loginProfile.gender,
        thumbSrc: this.loginProfile.thumbSrc,
      };

      console.log('WS送出', JSON.stringify(SEND_MSG));

      this.consultWebSocket.ws.send(JSON.stringify(SEND_MSG));
      
      this.handleWpSendNotification({
        // name: '【諮詢室】病患留言',
        title: 'Cancell 醫抗癌',
        msg: `【諮詢室】病患有新留言！`,
        url: 'https://cancell.tw/cms/chat',
        type: 'vendor',
        tid: `${this.vendorId}`,
      });

      this.sendMsg = '';
      this.showSendInterface = false;
      this.nextTick += 1;
    },

    handleSendNewMessageAiConsult() {
      if (!this.verifyAllPass) { return; }

      this.detectAiReply = true;

      const sendProcess = new Promise((resolve) => {
        const SEND_MSG = {
          category: 'text',
          user_type: this.loginProfile.user_type,
          message: this.sendMsg,
          username: this.loginDjangoId,
          room: `${this.vendorId}-${this.loginHashCode}-${this.loginDjangoId}`,
          first_name: this.loginProfile.firstName,
          last_name: this.loginProfile.lastName,
          gender: this.loginProfile.gender,
          thumbSrc: this.loginProfile.thumbSrc,
        };
  
        console.log('WS送出', JSON.stringify(SEND_MSG));
        this.consultWebSocket.ws.send(JSON.stringify(SEND_MSG));

        return resolve({
          user_type: this.loginProfile.user_type,
          message: this.sendMsg,
          username: this.loginDjangoId,
          room: `${this.vendorId}-${this.loginHashCode}-${this.loginDjangoId}`,
        });
      });

      sendProcess.then((value) => {

        if (value) {
          this.sendMsg = '';
          this.showSendInterface = false;
          this.nextTick += 1;
  
          postAiConsultation('', {
            auth_id: value.username,
            user_type: value.user_type,
            input_content: value.message,
            room: value.room
          }, {})
          .then((res) => {
            console.log('Ai Consultation Send');
          })
          .catch((err) => {
            console.log('error');
            this.detectAiReply = false;
            if (err.response.data === 'need subscribe') {
              this.handleClickShowSubscribeExpire();
            }
          })
        }
      })
    },

    uploadNewPhoto() {
      if (this.errorDetect) {
        console.log('errorDetect 偵測到錯誤!');
        this.wsRoom = null;

        this.changePopBoxStatus({
          active: true,
          include: 'warnWebSocketError',
        });
      } else {
        this.changePopBoxStatus({
          active: true,
          include: 'fileChatUpload',
        });
      }
    },

    speechInputMessage() {
      if (this.errorDetect) {
        console.log('errorDetect 偵測到錯誤!');
        this.wsRoom = null;

        this.changePopBoxStatus({
          active: true,
          include: 'warnWebSocketError',
        });
      } else {
        this.changePopBoxStatus({
          active: true,
          include: 'speechInput',
        });
      }
    },

    // detectWaitForReply(value) {
    //   const SEND_MSG = {
    //     category: 'auto-text',
    //     user_type: this.loginProfile.user_type,
    //     message: `${value.notes}，請醫師回覆與補充說明。`,
    //     username: this.loginDjangoId,
    //     room: `${this.vendorId}-${this.loginHashCode}-${this.loginDjangoId}`,
    //     first_name: this.loginProfile.firstName,
    //     last_name: this.loginProfile.lastName,
    //     gender: this.loginProfile.gender,
    //     thumbSrc: this.loginProfile.thumbSrc,
    //     notes: value.index,
    //   };

    //   console.log('WS送出', JSON.stringify(SEND_MSG));
    //   this.consultWebSocket.ws.send(JSON.stringify(SEND_MSG));
    // },

    // detectScrollToMessage(value) {
    //   const element = document.getElementById(`${value.dialog}-${value.index}`);
    //   const top = element.offsetTop;

    //   if (this.rwdType === 'desktop' && element) {
    //     element.scrollIntoView({
    //       behavior: 'smooth',
    //       block: 'start'
    //     });
    //   } else if (this.rwdType !== 'desktop' && element) {
    //     window.scrollTo({
    //       top: top,
    //       behavior: 'smooth',
    //     });
    //   }
    // },

    handleFormsCheckToPass() {

      if (this.errorDetect) {
        console.log('errorDetect 偵測到錯誤!');
        this.wsRoom = null;
        this.verifyAllPass = false;

        this.changePopBoxStatus({
          active: true,
          include: 'warnWebSocketError',
        });
      } else {
        this.verifyAllPass = true;
  
        if (!this.sendMsg) {
          console.log('sendMsg Error');
          this.sendMsgError = true;
          this.sendMsgErrorLog = '請輸入訊息';
          this.verifyAllPass = false;
        }
      }
    },

    // detectRoomTyping: debounce(function (e) {
    //   if (this.sendMsg) {
    //     console.log('Updating...');
    //     this.consultWebSocket.ws.send(JSON.stringify({
    //       category: 'text',
    //       message: 'typing',
    //       user_type: '',
    //       username: '',
    //       room: '',
    //       first_name: '',
    //       last_name: '',
    //       gender: '',
    //       thumbSrc: '',
    //     }));
    //   }
    // }, 300),

    // downloadChatRecord: debounce(function (e) {
    //   const PASS_CONFIG = {
    //     auth_id: `${this.loginDjangoId}`,
    //     team_id: '1',
    //     agent: 'mobile'
    //   };

    //   putChatRoomRecordDownload('', PASS_CONFIG, {
    //       responseType: 'blob'
    //     })
    //     .then((res) => {
    //       console.log('Chat Record Download', res.data, url);
    //       const url = window.URL.createObjectURL(new Blob([res.data]));
    //       const link = document.createElement('a');
    //       link.href = url;
    //       link.setAttribute('download', `user${this.loginDjangoId}_chatRecord.csv`);
    //       document.body.appendChild(link);
    //       link.click();
    //     })
    //     .catch((err) => {
    //     })
    // }, 300),

    async handleCheckProgressBeforeSend() {
      await this.handleFormsCheckToPass();
      await this.handleSendNewMessage();
    },

    async handleCheckProgressBeforeAiSend() {
      await this.handleFormsCheckToPass();
      await this.handleSendNewMessageAiConsult();
    },

    debounceSendNewMessage: debounce(async function(e) {
      this.handleCheckProgressBeforeSend();
    }, 100),

    // debounceSendNewMessageWithAi: debounce(async function(e) {
    //   this.subscribeVip === 'yes' ? this.handleCheckProgressBeforeAiSend() : this.handleClickShowSubscribeExpire()
    // }, 100),

    debounceSendNewMessageWithAi: debounce(async function(e) {
      this.handleCheckProgressBeforeAiSend()
    }, 100),
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      // authJwtToken: 'user/exportUserJwtToken',
      subscribeVip: 'user/exportUserSubscribeVip',
      loginHashCode: 'user/exportUserHashCode',
      consultChatVendor: 'user/exportConsultChatVendor',
      consultWebSocket: 'user/exportConsultWebSocket',
    }),

    // errorDetect() {
    //   return !this.wsRoom || this.wsReadState === 3;
    // },
  },

  watch: {
    $route(to, from) {    
      console.log('route', this.$route);
      if (to.name === 'effect-chatRoom' && this.$route.query.v) {
        this.chatStep = 2;
      } else {
        this.chatStep = 1;
      }
    },

    rwdType() {
      this.initRoomWebsocket();
    },

    errorDetect() {
      if (this.errorDetect) {
        console.log('errorDetect 偵測到錯誤!');
        this.wsRoom = null;

        setTimeout(() => {
          this.changePopBoxStatus({
            active: true,
            include: 'warnWebSocketError',
          });
        }, 2000);
      }
    },
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectChatRoom.scss';
</style>
